import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './annuals.constants';
import * as types from './annuals.types';
import * as services from './annuals.saga-services';

function* invokeCreateAnnual(action: types.ICreateAnnualAction) {
  yield call(services.createAnnual, action.payload);
}

function* invokeUpdateAnnual(action: types.IUpdateAnnualAction) {
  yield call(services.updateAnnual, action.payload.annualId, action.payload.payload);
}

function* invokeDeleteAnnual(action: types.IUpdateAnnualAction) {
  yield call(services.deleteAnnual, action.payload.annualId);
}

export function* watchAnnualsPageSaga() {
  yield takeLatest(constants.CREATE_ANNUAL, invokeCreateAnnual);
  yield takeLatest(constants.UPDATE_ANNUAL, invokeUpdateAnnual);
  yield takeLatest(constants.DELETE_ANNUAL, invokeDeleteAnnual);
}
